import { makeStyles } from '@mui/styles';

export const useAccordionReportHeaderStyles = makeStyles(muiTheme => ({
  button: {
    borderColor: muiTheme.palette.primary.main,
    textTransform: 'none',
  },
}));
